import React, {
  useEffect,
  useState,
} from "react";

import {
  FiEdit3,
  FiSave,
  FiX,
} from "react-icons/fi";


const OrderNotes = ({
  open,
  order,
  loading = false,
  onClose,
  onSubmit,
}) => {
  const [
    notes,
    setNotes,
  ] = useState("");


  useEffect(() => {
    if (!open) {
      return;
    }

    setNotes(
      order?.notes ||
      ""
    );

  }, [
    open,
    order?._id,
  ]);


  if (!open) {
    return null;
  }


  const handleClose =
    () => {
      if (loading) {
        return;
      }

      if (
        typeof onClose ===
        "function"
      ) {
        onClose();
      }
    };


  const handleSubmit =
    (
      event
    ) => {
      event.preventDefault();


      if (loading) {
        return;
      }


      if (
        typeof onSubmit ===
        "function"
      ) {
        onSubmit({
          notes:
            String(
              notes || ""
            ).trim(),
        });
      }
    };


  return (
    <div
      className="order-dialog-overlay"
    >
      <button
        type="button"
        className="order-dialog-backdrop"
        onClick={
          loading
            ? undefined
            : handleClose
        }
        aria-label="Close order notes dialog"
      />


      <div
        className="order-dialog order-notes-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="order-notes-title"
      >
        <div
          className="order-dialog-header"
        >
          <div
            className="order-dialog-header-icon notes"
          >
            <FiEdit3 />
          </div>


          <div
            className="order-dialog-header-content"
          >
            <span>
              INTERNAL NOTES
            </span>


            <h3
              id="order-notes-title"
            >
              Order Notes
            </h3>


            <p>
              {order?.orderNumber ||
                "Order"}
            </p>
          </div>


          <button
            type="button"
            className="order-dialog-close"
            onClick={
              handleClose
            }
            disabled={
              loading
            }
            aria-label="Close"
          >
            <FiX />
          </button>
        </div>


        <form
          onSubmit={
            handleSubmit
          }
        >
          <div
            className="order-dialog-body"
          >
            <div
              className="order-dialog-field"
            >
              <label>
                Internal Admin Notes
              </label>


              <textarea
                rows={7}
                value={
                  notes
                }
                onChange={(
                  event
                ) =>
                  setNotes(
                    event.target
                      .value
                  )
                }
                maxLength={3000}
                placeholder="Add information useful for internal order handling..."
                disabled={
                  loading
                }
                autoFocus
              />


              <div
                className="order-field-meta"
              >
                <span>
                  Visible to admin only
                </span>


                <span>
                  {notes.length}/3000
                </span>
              </div>
            </div>
          </div>


          <div
            className="order-dialog-footer"
          >
            <button
              type="button"
              className="secondary"
              onClick={
                handleClose
              }
              disabled={
                loading
              }
            >
              Cancel
            </button>


            <button
              type="submit"
              className="primary"
              disabled={
                loading
              }
            >
              {loading ? (
                <>
                  <span
                    className="order-button-spinner"
                  />

                  Saving...
                </>
              ) : (
                <>
                  <FiSave />

                  Save Notes
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};


export default
  OrderNotes;